import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import type { CompraFormValues } from '../../components/compras/compra.schema';
import CompraForm from '../../components/compras/CompraForm';
import type { CompraBusqueda } from '../../stores/compras/compra';
import { useComprasStore, type ActualizarCompraRequest } from '../../stores/compras/compra.store';
import { useCorralesStore } from '../../stores/corrales/corrales.store';

const EditarCompra = () => {
  const id = useParams<{ id: string }>().id ?? '';
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const {
    current: compra,
    actualizar,
    cancelar,
    cargarPorId,
    convertir,
    nueva,
    forceReload,
    historialSiiniga,
    historialTemporal,
    cargarHistorialSiiniga,
    cargarHistorialTemporal
  } = useComprasStore();
  const { actives: corrales, cargarActivos: cargarCorrales } = useCorralesStore();

  useEffect(() => {
    if (!id) {
      nueva();
      return;
    }

    cargarCorrales();
    cargarPorId(id);
  }, [id, forceReload]);

  const handleSave = (values: CompraFormValues) => {
    return compra?.esCompra ? actualizarCompra(values) : convertirACompra(values);
  };

  const convertirACompra = (values: CompraFormValues) => {
    const request = {
      partidas: values.animales.map((a, i) => ({
        partida: i + 1,
        omiteDescuento: false,
        precio: a.precio
      }))
    };
    return convertir(id, request);
  };

  const actualizarCompra = (values: CompraFormValues) => {
    const request: ActualizarCompraRequest = {
      fecha: values.fecha.toDate(),
      idCorral: values.idCorral,
      idPersonaEntrega: values.idPersonaEntrega,
      idPersonaRecibe: values.idPersonaRecibe,
      idPersonaVende: values.idPersonaVende,
      referencia: values.referencia
    };
    return actualizar(id, request);
  };

  const handleCompraSelect = (compra: CompraBusqueda) => {
    const index = pathname.replace('/editar', '').lastIndexOf('/');
    const basePath = index > 0 ? pathname.substring(0, index) : pathname;
    navigate(`${basePath}/editar/${compra.folioInterno}`);
  };

  const handleCancel = async () => {
    await cancelar(id);
  };

  const handleClear = async () => {
    const index = pathname.replace('/editar', '').lastIndexOf('/');
    const basePath = index > 0 ? pathname.substring(0, index) : pathname;
    navigate(`${basePath}`);
  };

  return (
    <CompraForm
      compra={compra}
      corrales={corrales}
      historialSiiniga={historialSiiniga}
      historialTemporal={historialTemporal}
      cargarHistorialSiiniga={cargarHistorialSiiniga}
      cargarHistorialTemporal={cargarHistorialTemporal}
      onSave={handleSave}
      onCancel={handleCancel}
      onClear={handleClear}
      onCompraSelected={handleCompraSelect}
    />
  );
};

export default EditarCompra;
